<template>
  <div id="app">
    <div id="wrapper">
      <SideBar title="shift2dc"></SideBar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <TopBar></TopBar>
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './components/SideBar.vue'
import TopBar from './components/TopBar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    SideBar,
    TopBar,
    Footer,
  },
  mounted: function(){
    $('[data-toggle="tooltip"]').tooltip()

    if(this.$store.getters.user_isAdmin) {
      this.$store.dispatch('getProducers').then(() => { return; })
    }
  }
}
</script>

<style>
.text-blue {
  color: #4187c7;
}
.text-green {
  color: #89b43f;
}
.text-orange{
  color: #f7882f;
}
.text-darkorange{
  color: #ef5e3c;
}
.border-top-1{
  border-top: 1px solid #e3e6f0;
}
.border-right-1{
  border-right: 1px solid #e3e6f0;
}
.py-10{
  padding-top: 10px;
  padding-bottom: 10px;
}

.bootstrap-select .btn{
  background-color: #f8f9fc!important;
}


@media only screen and (max-width: 767px) {
  .card-body {
    font-size: 14px!important;
  }
  .h4 {
    font-size: 1.3em;
  }
}

@media only screen and (max-width: 1366px) { 
  .col-xl-special-4, .col-xl-special-5 {
    /* width: 75% !important; */
    /* min-width: 75%; */
  }

  .col-xl-special-6 {
    width: 100%!important;
  }
}

@media only screen and (min-width: 1367px) { 
  .col-xl-special-4 {
    width: 33.3333%!important;
    min-width: 33.3333%;
  }
  
  .col-xl-special-5 {
    width: 41.6666%!important;
    min-width: 33.3333%;
  }

  .col-xl-special-6 {
    width: 50%!important;
    min-width: 50%;
  }

  .col-xl-special-6:first-of-type{
    border-right: solid 1px #dcdcdc
  }
}
</style>